
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB8gDtFV9vqRbpZfE7TiUQQHjqVREiW2K8",
  authDomain: "leadpro-710b6.firebaseapp.com",
  projectId: "leadpro-710b6",
  storageBucket: "leadpro-710b6.firebaseapp.com",
  messagingSenderId: "839555539229",
  appId: "1:839555539229:web:3ec8e8a7e2501726f901f4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);


export const LEGACY_TENANT_ID = "legacy";

export default app;
